import * as mobileUtils from '../Helpers/Auth0MobileUtils';
/**
 * Funcion de orden superior que chequea si se puede usar localStorage y si es asi
 * ejecuta la funcion pasada por parametro.
 * @param {Function} fn Funcion a ejecutar si se puede usar localStorage
 * @returns {Function} Funcion que ejecuta la funcion pasada por parametro si se puede usar localStorage
 */
const withLocalStorage =
    (fn) =>
    (...args) => {
        const urlForMobile = mobileUtils.getMobilePath(window.location.href);

        if (!mobileUtils.isMobileCallback(urlForMobile)) {
            return fn(...args);
        }
    };

const removeItem = withLocalStorage(function (key) {
    window.localStorage.removeItem(key);
});

const setExpiredItem = withLocalStorage(function (key, value) {
    let item = {
        value: value,
        expiration: new Date(),
    };

    window.localStorage.setItem(key, JSON.stringify(item));
});
/**
 *
 * @param {number} expirationDays 1 por defecto
 */
const setExpiredItemByDays = withLocalStorage(function (
    key,
    value,
    expirationDays = 1
) {
    const expiration = new Date();
    expiration.setDate(expiration.getDate() + expirationDays);

    let item = {
        value: value,
        expiration: expiration,
    };

    window.localStorage.setItem(key, JSON.stringify(item));
});

const setItem = withLocalStorage(function (key, value) {
    window.localStorage.setItem(key, JSON.stringify(value));
});
const getItem = withLocalStorage(function (key) {
    return JSON.parse(window.localStorage.getItem(key));
});

const renew = withLocalStorage(function (key) {
    let item = getItem(key);
    if (item.expiration) {
        item.expiration = new Date();

        window.localStorage.setItem(key, JSON.stringify(item));
    }
});
/**
 *
 * @param {*} expiration Expiracion por la que queremos comprar
 * @returns Si la expiracion todavia es valida retorna el item, sino null
 */
const checkExpiration = withLocalStorage(function (key, expiration) {
    let item = getItem(key);
    if (item.expiration) {
        let itemexpiration = new Date(item.expiration);

        let lifetime = expiration;

        if (new Date() - itemexpiration < lifetime) {
            return item;
        } else {
            return null;
        }
    }
    return null;
});

const checkIfExists = withLocalStorage(function (key) {
    return window.localStorage.getItem(key) != null;
});

export {
    removeItem,
    setExpiredItem,
    setItem,
    getItem,
    renew,
    checkExpiration,
    checkIfExists,
    setExpiredItemByDays,
};
